module.exports = __webpack_public_path__ + "img/icon-copy-doc.97d3f32c.svg";